import React from "react";

const Resume = () => {
    return (
        <>
            <h1>Custom Reports</h1>
        </>
    );
}

export {Resume};